import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
} from '@mui/material';
import {
  Assignment as AssignmentIcon,
  Description as DescriptionIcon,
  Mic as MicIcon,
  Psychology as PsychologyIcon,
} from '@mui/icons-material';
import { PageHeader } from '../../components/common';
import { useAuthStore } from '../../hooks/useAuth';

interface StatCardProps {
  title: string;
  value: string | number;
  icon: React.ReactNode;
  color: string;
}

const StatCard: React.FC<StatCardProps> = ({ title, value, icon, color }) => (
  <Card>
    <CardContent>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Box>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            {title}
          </Typography>
          <Typography variant="h4" fontWeight={600}>
            {value}
          </Typography>
        </Box>
        <Box
          sx={{
            width: 56,
            height: 56,
            borderRadius: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: `${color}20`,
            color: color,
          }}
        >
          {icon}
        </Box>
      </Box>
    </CardContent>
  </Card>
);

const DashboardPage: React.FC = () => {
  const { user } = useAuthStore();

  return (
    <Box>
      <PageHeader
        title={`안녕하세요, ${user?.name || user?.username || '사용자'}님`}
        subtitle="오늘의 업무 현황을 확인하세요."
      />

      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="총 상담 기록"
            value={0}
            icon={<AssignmentIcon fontSize="large" />}
            color="#5D87FF"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="생성된 문서"
            value={0}
            icon={<DescriptionIcon fontSize="large" />}
            color="#13DEB9"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="처리된 녹음"
            value={0}
            icon={<MicIcon fontSize="large" />}
            color="#FFAE1F"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="AI 요약"
            value={0}
            icon={<PsychologyIcon fontSize="large" />}
            color="#FA896B"
          />
        </Grid>
      </Grid>

      <Grid container spacing={3} sx={{ mt: 1 }}>
        <Grid item xs={12} md={8}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                최근 상담 기록
              </Typography>
              <Typography variant="body2" color="text.secondary">
                아직 상담 기록이 없습니다.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                빠른 작업
              </Typography>
              <Typography variant="body2" color="text.secondary">
                새 상담 기록을 시작하세요.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DashboardPage;
